module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/rap-9c9fa0a99c59f80db64a8a4389f0bc2b.png";